import React, { useState, useEffect } from "react";
import PastScans from "./PastScans";
import { apifetch } from '../services/interceptors';
import { 
  Spinner, 
  Card, 
  Row, 
  Col, 
  Badge,
  InputGroup,
  FormControl,
  Button,
  Modal,
  Form,
  FloatingLabel,
  Alert,
  Tooltip,
  OverlayTrigger,
  Dropdown,
  ButtonGroup,
  Collapse
} from 'react-bootstrap';
import { useTheme } from "../ThemeContext";
import { 
  TbBuilding, 
  TbCalendar, 
  TbClock,
  TbSearch,
  TbChevronDown,
  TbChevronUp,
  TbSortAscending,
  TbRefresh,
  TbPlus,
  TbFilter,
  TbX,
  TbArrowsSort,
  TbCalendarEvent,
  TbCalendarTime,
  TbSortAscending2,
  TbSortDescending2
} from "react-icons/tb";
import { format, formatDistanceToNow, isAfter, isBefore, parseISO } from 'date-fns';
import Online_PastScans from "./PastScans_online";

const OrganizationList = ({ isAdmin }) => {
  const [organizations, setOrganizations] = useState([]);
    const [organizationName, setOrganizationName] = useState('');
      const [orgmessage, setOrgMessage] = useState('');
      const formRef = React.useRef(null);
    
    const [primaryPerson, setPrimaryPerson] = useState('');
    const [orgerror, setOrgError] = useState(null);
    const [primaryEmail, setPrimaryEmail] = useState('');
    const [primaryPhone, setPrimaryPhone] = useState('');
    const [website, setWebsite] = useState('');

  const [showOrgForm, setShowOrgForm] = useState(false);

  const [filteredOrganizations, setFilteredOrganizations] = useState([]);
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: 'name', direction: 'ascending' });
  const [showCreateModal, setShowCreateModal] = useState(false);
  // const [isAdmin, setIsAdmin] = useState(false);
  const [isInternal, setIsInternal] = useState(true);
  const [createForm, setCreateForm] = useState({
    name: "",
    description: ""
  });
  const [createLoading, setCreateLoading] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    createdDateFrom: "",
    createdDateTo: "",
    updatedDateFrom: "",
    updatedDateTo: "",
    sortBy: "name",
    sortOrder: "asc"
  });
  const token = localStorage.getItem('token');
  const { isDarkMode } = useTheme();

  const themeStyles = {
    backgroundColor: isDarkMode ? "#121212" : "#f5f7fa",
    color: isDarkMode ? "#ffffff" : "#212529",
    minHeight: "100vh",
    paddingBottom: "50px"
  };

  const cardThemeStyles = {
    backgroundColor: isDarkMode ? "#1e1e1e" : "#ffffff",
    color: isDarkMode ? "#ffffff" : "#212529",
    border: 'none',
    borderRadius: '12px',
    boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.3)' : '0 4px 20px rgba(0,0,0,0.05)'
  };

  const inputThemeStyles = {
    backgroundColor: isDarkMode ? '#2a2a2a' : '#fff',
    color: isDarkMode ? '#ffffff' : '#212529',
    borderColor: isDarkMode ? '#444' : '#ced4da',
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  // const checkAdminStatus = () => {
  //   const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  //   setIsAdmin(userData.isAdmin || false);
  // };

  const fetchOrganizations = async () => {
    setLoading(true);
    try {
      const response = await apifetch('s1/api/organizations', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch organizations');
      }
      const data = await response.json();
      setOrganizations(data.organizations);
      setFilteredOrganizations(data.organizations);
      setError("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  const handleRefresh = () => {
    setRefreshing(true);
    fetchOrganizations();
  };

  useEffect(() => {
    let result = [...organizations]; 
  
    // Apply search filter
    if (searchTerm) {
      result = result.filter(org => 
        org.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        (org.description && org.description.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
  
    // Apply date filters
    if (filters.createdDateFrom) {
      const fromDate = new Date(filters.createdDateFrom);
      result = result.filter(org => isAfter(parseISO(org.created_date), fromDate));
    }
 
    if (filters.createdDateTo) {
      const toDate = new Date(filters.createdDateTo);
      result = result.filter(org => isBefore(parseISO(org.created_date), toDate));
    }
  
    if (filters.updatedDateFrom) {
      const fromDate = new Date(filters.updatedDateFrom);
      result = result.filter(org => isAfter(parseISO(org.update_date), fromDate));
    }
  
    if (filters.updatedDateTo) {
      const toDate = new Date(filters.updatedDateTo);
      result = result.filter(org => isBefore(parseISO(org.update_date), toDate));
    }
  
    // Apply sorting
    if (filters.sortBy) {
      result.sort((a, b) => {
        let aValue = a[filters.sortBy];
        let bValue = b[filters.sortBy];
        
        if (filters.sortBy.includes('date')) {
          aValue = new Date(aValue).getTime();
          bValue = new Date(bValue).getTime();
        }
  
        if (aValue < bValue) return filters.sortOrder === 'asc' ? -1 : 1;
        if (aValue > bValue) return filters.sortOrder === 'asc' ? 1 : -1;
        return 0;
      });
    }
  
    setFilteredOrganizations(result);
  }, [organizations, searchTerm, filters]);
  
   
  const handleSort = (key) => {
    setFilters(prev => ({
      ...prev,
      sortBy: key,
      sortOrder: prev.sortBy === key && prev.sortOrder === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleOrgClick = (orgId) => {
    setSelectedOrgId(orgId === selectedOrgId ? null : orgId);
  };

  const getSortIcon = (key) => {
    if (filters.sortBy !== key) return <TbArrowsSort size={16} />;
    return filters.sortOrder === 'asc' ? <TbSortAscending2 size={16} /> : <TbSortDescending2 size={16} />;
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, 'MMM dd, yyyy');
    } catch (error) {
      return 'Invalid date';
    }
  };

  const formatRelativeTime = (dateString) => {
    try {
      const date = new Date(dateString);
      return formatDistanceToNow(date, { addSuffix: true });
    } catch (error) {
      return 'Invalid date';
    }
  };

  const formatDetailedDate = (dateString) => {
    try {
      const date = new Date(dateString);
      return format(date, 'PPpp');
    } catch (error) {
      return 'Invalid date';
    }
  };

  const handleCreateOrganization = async (e) => {
    e.preventDefault();
    setCreateLoading(true);
    setError("");

    try {
      const response = await apifetch('s1/api/organizations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(createForm)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to create organization');
      }

      setSuccess("Organization created successfully!");
      setShowCreateModal(false);
      setCreateForm({ name: "", description: "" });
      
      setTimeout(() => {
        setSuccess("");
        fetchOrganizations();
      }, 2000);
    } catch (err) {
      setError(err.message);
    } finally {
      setCreateLoading(false);
    }
  };

  const clearFilters = () => {
    setFilters({
      createdDateFrom: "",
      createdDateTo: "",
      updatedDateFrom: "",
      updatedDateTo: "",
      sortBy: "name",
      sortOrder: "asc"
    });
    setSearchTerm("");
  };
  const CreateOrganization = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const response = await apifetch('s1/api/create_organization', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
          body: JSON.stringify({ 
            primaryPerson,
            primaryEmail,
            primaryPhone,
            website,
            name: organizationName
          }),
        });
  
        const data = await response.json();
        if (!response.ok) {
          setOrgError(data.error || "Can't create organization");
        } else {
          setOrganizations((prevOrg) => [...prevOrg, data.organization]);
          setOrganizationName('');
          setWebsite('');
          setPrimaryPerson('');
          setPrimaryEmail('');
          setPrimaryPhone('');
          setShowOrgForm(false);
          setOrgMessage('Organization created successfully');
        }
      } catch (error) {
        setOrgError(`Error creating organization: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

  const hasActiveFilters = () => {
    return searchTerm || 
           filters.createdDateFrom || 
           filters.createdDateTo || 
           filters.updatedDateFrom || 
           filters.updatedDateTo;
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
        <Spinner animation="border" variant="primary" />
        <span className="ms-2">Loading organizations...</span>
      </div>
    );
  }

  return (
    <div className="container-fluid py-4" style={themeStyles}>
      <Row className="justify-content-center">
        <Col xl={10} xxl={8}>
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <div>
              <h2 className="mb-1">Organizations</h2>
              <p className=" mb-0">Manage and view all your organizations</p>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-2">
              <Badge bg="primary" pill className="fs-6 px-3 py-2">
                {filteredOrganizations.length} {filteredOrganizations.length === 1 ? 'Organization' : 'Organizations'}
              </Badge>
              <Button 
                variant="outline-primary" 
                className="d-flex align-items-center"
                onClick={handleRefresh}
                disabled={refreshing}
              >
                <TbRefresh className={`me-1 ${refreshing ? 'spin-animation' : ''}`} />
                Refresh
              </Button>
              {isAdmin===1 && (
               <Button
                        variant="primary"
                        size="sm"
                        onClick={() => setShowOrgForm(!showOrgForm)}
                        className="d-flex align-items-center"
                      >
                        {showOrgForm ? (
                          <>
                            <span className="me-1">Cancel</span>
                          </>
                        ) : (
                          <>
                            <TbBuilding className="me-1" />
                            New Organization
                          </>
                        )}
                </Button>
              )}
            </div>
          </div>

          {/* Alerts */}
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError("")} className="mb-3">
              {error}
            </Alert>
          )}
          {success && (
            <Alert variant="success" dismissible onClose={() => setSuccess("")} className="mb-3">
              {success}
            </Alert>
          )}

          {/* Search and Filter Card */}
          <Card style={cardThemeStyles} className="mb-4">
            <Card.Body className="p-3">
              <Row className="g-3 align-items-end">
                <Col md={6} lg={5}>
                  <Form.Label className="form-label">Search organizations</Form.Label>
                  <InputGroup>
                    <InputGroup.Text style={inputThemeStyles}>
                      <TbSearch />
                    </InputGroup.Text>
                    <FormControl
                      placeholder="Search by name or description..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                      style={inputThemeStyles}
                    />
                  </InputGroup>
                </Col>
                <Col md={6} lg={7}>
                  <div className="d-flex gap-2 flex-wrap">
                    <Button
                      variant={showFilters ? "primary" : "outline-primary"}
                      onClick={() => setShowFilters(!showFilters)}
                      className="d-flex align-items-center"
                    >
                      <TbFilter className="me-1" />
                      Filters
                      {hasActiveFilters() && (
                        <Badge bg="light" text="dark" className="ms-1">
                          !
                        </Badge>
                      )}
                    </Button>
                    
                    <Dropdown as={ButtonGroup}>
                      <Button 
                        variant="outline-secondary" 
                        className="d-flex align-items-center"
                      >
                        <TbArrowsSort className="me-1" />
                        Sort
                      </Button>
                      <Dropdown.Toggle split variant="outline-secondary" />
                      <Dropdown.Menu  style={cardThemeStyles}>
                        <Dropdown.Item 
                          onClick={() => handleSort('name')}
                          className="d-flex align-items-center"
                          style={{color:isDarkMode?'white':'black'}}
                        >
                          Name {getSortIcon('name')}
                        </Dropdown.Item>
                        <Dropdown.Item 
                          onClick={() => handleSort('created_date')}
                          className="d-flex align-items-center"
                          style={{color:isDarkMode?'white':'black'}}
                        >
                          Created Date {getSortIcon('created_date')}
                        </Dropdown.Item>
                        <Dropdown.Item 
                          onClick={() => handleSort('update_date')}
                          className="d-flex align-items-center"
                          style={{color:isDarkMode?'white':'black'}}
                        >
                          Updated Date {getSortIcon('update_date')}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    
                    {hasActiveFilters() && (
                      <Button
                        variant="outline-danger"
                        onClick={clearFilters}
                        className="d-flex align-items-center"
                        style={{color:isDarkMode?'white':'black'}}
                      >
                        <TbX className="me-1" />
                        Clear Filters
                      </Button>
                    )}
                  </div>
                </Col>
              </Row>

              {/* Advanced Filters Collapse */}
              <Collapse in={showFilters}>
                <div className="mt-4 pt-3 border-top">
                  <h6 className="mb-3">Advanced Filters</h6>
                  <Row className="g-3">
                    <Col md={6} lg={3}>
                      <Form.Label className="form-label">Created From</Form.Label>
                      <InputGroup>
                        <InputGroup.Text style={inputThemeStyles}>
                          <TbCalendarEvent />
                        </InputGroup.Text>
                        <FormControl
                          type="date"
                          value={filters.createdDateFrom}
                          onChange={(e) => setFilters({...filters, createdDateFrom: e.target.value})}
                          style={inputThemeStyles}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Label className="form-label">Created To</Form.Label>
                      <InputGroup>
                        <InputGroup.Text style={inputThemeStyles}>
                          <TbCalendarEvent />
                        </InputGroup.Text>
                        <FormControl
                          type="date"
                          value={filters.createdDateTo}
                          onChange={(e) => setFilters({...filters, createdDateTo: e.target.value})}
                          style={inputThemeStyles}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Label className="form-label">Updated From</Form.Label>
                      <InputGroup>
                        <InputGroup.Text style={inputThemeStyles}>
                          <TbCalendarTime />
                        </InputGroup.Text>
                        <FormControl
                          type="date"
                          value={filters.updatedDateFrom}
                          onChange={(e) => setFilters({...filters, updatedDateFrom: e.target.value})}
                          style={inputThemeStyles}
                        />
                      </InputGroup>
                    </Col>
                    <Col md={6} lg={3}>
                      <Form.Label className="form-label">Updated To</Form.Label>
                      <InputGroup>
                        <InputGroup.Text style={inputThemeStyles}>
                          <TbCalendarTime />
                        </InputGroup.Text>
                        <FormControl
                          type="date"
                          value={filters.updatedDateTo}
                          onChange={(e) => setFilters({...filters, updatedDateTo: e.target.value})}
                          style={inputThemeStyles}
                        />
                      </InputGroup>
                    </Col>
                  </Row>
                </div>
              </Collapse>
            </Card.Body>
          </Card>

{/* Create Organization Modal */}
<Modal  show={showOrgForm} onHide={() => setShowOrgForm(false)} centered size="lg"   contentClassName={isDarkMode ? "bg-dark text-light" : ""}
>
  <Modal.Header closeButton className={isDarkMode ? 'bg-dark text-light' : ''}>
    <Modal.Title>
      <TbBuilding className="me-2" />
      Create New Organization
    </Modal.Title>
  </Modal.Header>
  <Modal.Body className={isDarkMode ? 'bg-dark text-light' : ''}>
    <Form id="orgForm" onSubmit={CreateOrganization}>
      <Form.Group className="mb-3">
        <Form.Label>Organization Name</Form.Label>
        <Form.Control
          type="text"
          value={organizationName}
          onChange={(e) => setOrganizationName(e.target.value)}
          placeholder="Enter organization name"
          required
          className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Website (Domain)</Form.Label>
        <Form.Control
          type="text"
          value={website}
          onChange={(e) => setWebsite(e.target.value)}
          placeholder="Enter organization website (e.g. example.com)"
          className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Primary Person Name</Form.Label>
        <Form.Control
          type="text"
          value={primaryPerson}
          onChange={(e) => setPrimaryPerson(e.target.value)}
          placeholder="Enter primary contact name"
          required
          className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
        />
      </Form.Group>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Primary Email</Form.Label>
            <Form.Control
              type="email"
              value={primaryEmail}
              onChange={(e) => setPrimaryEmail(e.target.value)}
              placeholder="Enter email"
              required
              className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Primary Phone</Form.Label>
            <Form.Control
              type="tel"
              value={primaryPhone}
              onChange={(e) => setPrimaryPhone(e.target.value)}
              placeholder="Enter phone"
              required
              className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
            />
          </Form.Group>
        </Col>
      </Row>
    </Form>
  </Modal.Body>
  <Modal.Footer className={isDarkMode ? 'bg-dark' : ''}>
    <Button variant="secondary" onClick={() => setShowOrgForm(false)}>
      Cancel
    </Button>
    <Button 
      variant="success" 
      type="submit"
      form="orgForm"
      disabled={loading}
    >
      {loading ? (
        <>
          <Spinner animation="border" size="sm" className="me-2" />
          Creating...
        </>
      ) : (
        <>
          <TbBuilding className="me-1" />
          Create Organization
        </>
      )}
    </Button>
  </Modal.Footer>
</Modal>

          {/* Organizations List */}
          {filteredOrganizations.length === 0 ? (
            <Card style={cardThemeStyles}>
              <Card.Body className="text-center py-5">
                <TbBuilding size={48} className=" mb-3" />
                <h5>No organizations found</h5>
                <p className=" mb-4">
                  {hasActiveFilters() ? 'Try adjusting your filters' : 'No organizations available yet'}
                </p>
                {hasActiveFilters() ? (
                  <Button variant="outline-primary" onClick={clearFilters}>
                    Clear Filters
                  </Button>
                ) : isAdmin===1 ? (
                  <Button 
                    variant="primary" 
                    onClick={() => setShowCreateModal(true)}
                  >
                    Create Your First Organization
                  </Button>
                ) : null}
              </Card.Body>
            </Card>
          ) : (
            <div className="organizations-list">
              {filteredOrganizations.map((org) => (
                <Card 
                  key={org.id} 
                  style={cardThemeStyles} 
                  className="mb-3 organization-card"
                >
                  <Card.Body className="p-0">
                    <div 
                      className="p-3 d-flex justify-content-between align-items-center cursor-pointer"
                      onClick={() => handleOrgClick(org.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div className="d-flex align-items-center">
                        <div className="organization-icon me-3">
                          <TbBuilding size={24} className="text-primary" />
                        </div>
                        <div>
                          <h6 className="mb-1 fw-semibold">{org.name}</h6>
                          {org.description && (
                            <p className=" mb-0 small">{org.description}</p>
                          )}
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-3">
                        <div className="text-end d-none d-md-block">
                          <small className=" d-block">
                            Created: {formatDate(org.created_date)}
                          </small>
                          <small className="">
                            Updated: {formatRelativeTime(org.update_date)}
                          </small>
                        </div>
                        <div className={`chevron ${selectedOrgId === org.id ? 'rotate' : ''}`}>
                          <TbChevronDown />
                        </div>
                      </div>
                    </div>
                    
                  <Collapse in={selectedOrgId === org.id}>
  <div className="border-top p-3">

    {/* Toggle */}
    <div className="d-flex justify-content-between align-items-center mb-3">
      <div>
        <div className="fw-semibold">Scan Source</div>
        <small className={isDarkMode ? "text-gray" : "text-muted"}>
          Choose where scan results come from
        </small>
      </div>

      <div className="btn-group" role="group">
        <button
          className={`btn btn-sm ${
            isInternal ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => setIsInternal(true)}
        >
          Internal
        </button>
        <button
          className={`btn btn-sm ${
            !isInternal ? 'btn-primary' : 'btn-outline-primary'
          }`}
          onClick={() => setIsInternal(false)}
        >
          External
        </button>
      </div>
    </div>

    {/* Content */}
    {isInternal ? (
      <PastScans organizationid={org.id} />
    ) : (
      <Online_PastScans organizationid={org.id} />
    )}

  </div>
</Collapse>



                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </Col>
      </Row>

      {/* Create Organization Modal */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} centered size="lg">
        <Modal.Header closeButton style={cardThemeStyles}>
          <Modal.Title>Create New Organization</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCreateOrganization}>
          <Modal.Body style={cardThemeStyles}>
            <Row>
              <Col md={12}>
                <FloatingLabel label="Organization Name" className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Organization Name"
                    value={createForm.name}
                    onChange={(e) => setCreateForm({...createForm, name: e.target.value})}
                    className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                    style={inputThemeStyles}
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col md={12}>
                <FloatingLabel label="Description (Optional)">
                  <Form.Control
                    as="textarea"
                    placeholder="Description"
                    style={{...inputThemeStyles, height: '100px'}}
                    value={createForm.description}
                    onChange={(e) => setCreateForm({...createForm, description: e.target.value})}
                    className={isDarkMode ? 'bg-dark text-light placeholder-light' : ''}
                  />
                </FloatingLabel>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={cardThemeStyles}>
            <Button variant="outline-secondary" onClick={() => setShowCreateModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit" disabled={createLoading}>
              {createLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Creating...
                </>
              ) : (
                'Create Organization'
              )}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .spin-animation {
            animation: spin 1s linear infinite;
          }
          .organization-card {
            transition: transform 0.2s ease, box-shadow 0.2s ease;
          }
          .organization-card:hover {
            transform: translateY(-2px);
            box-shadow: ${isDarkMode 
              ? '0 6px 25px rgba(0,0,0,0.4)' 
              : '0 6px 25px rgba(0,0,0,0.1)'} !important;
          }
          .cursor-pointer {
            cursor: pointer;
          }
          .chevron {
            transition: transform 0.3s ease;
          }
          .chevron.rotate {
            transform: rotate(180deg);
          }
          .organizations-list {
            display: grid;
            gap: 0.75rem;
          }
          @media (max-width: 768px) {
            .organization-icon {
              display: none;
            }
          }
        `}
      </style>
    </div>
  );
};

export default OrganizationList;